// extracted by mini-css-extract-plugin
export default {"popup":"TechnicalPage_popup__D2Tl8","textBlock":"TechnicalPage_textBlock__lLj+C"};